import { render, staticRenderFns } from "./SetauthenticationType.vue?vue&type=template&id=738892f2"
import script from "./SetauthenticationType.vue?vue&type=script&lang=js"
export * from "./SetauthenticationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports